import React from "react";

export const Row = ({ children, ...props }) => {
  return (
    <div className="row" {...props}>
      {children}
    </div>
  );
};
